import { costOfGas, totalCostOfUserOp } from './balance';
import { NegativeValueException } from '../../../errors';
import { getAction } from 'viem/utils';
import { getBalance } from 'viem/actions';
import { doubleGasIfLocalAnvil } from '../../../utils/anvilGasLimit';
/**
 * Adjusts the value relative to the balance of a wallet
 *
 * This is applicable for instances where the max balance is passed.
 * In this case, the value + gas cost would exceed the balance of the wallet.
 * So, the value is adjusted to subtract the gas cost from the value.
 *
 * @returns the adjusted value or the original value
 */
export function adjustValueRelativeToBalance({ balance, value, callGasLimit, preVerificationGas, verificationGasLimit, maxFeePerGas, chainId, }) {
    const totalCost = totalCostOfUserOp({
        gasLimit: callGasLimit,
        preVerificationGas,
        verificationGasLimit,
        gasPrice: maxFeePerGas,
        value,
    });
    if (totalCost > balance) {
        const gasCost = costOfGas({
            gasLimit: callGasLimit,
            preVerificationGas,
            verificationGasLimit,
            gasPrice: maxFeePerGas,
        });
        // a little extra buffer to account for estimates
        const valueMinusGas = value - doubleGasIfLocalAnvil(chainId, gasCost);
        if (valueMinusGas < 0n) {
            throw new NegativeValueException();
        }
        return valueMinusGas;
    }
    else {
        return value;
    }
}
export async function subtractGasFromBalance({ gas, client, value, functionHash, smartAccount, chainId, }) {
    if (functionHash !== 'transferEth') {
        return;
    }
    const { preVerificationGas, callGasLimit, maxFeePerGas, verificationGasLimit } = gas;
    if (!callGasLimit || !preVerificationGas || !verificationGasLimit || !maxFeePerGas) {
        throw new Error('Missing required properties');
    }
    const balance = await getAction(client, getBalance, 'getBalance')({
        address: smartAccount.address,
    });
    return adjustValueRelativeToBalance({
        balance,
        callGasLimit,
        preVerificationGas,
        verificationGasLimit,
        maxFeePerGas,
        value,
        chainId,
    });
}
